import { h } from 'vue'
import { RouterView } from 'vue-router'
import type { FunctionalComponent } from 'vue'
import type {
  LocationQueryValue,
  RouteLocation,
  RouteRecordRaw,
} from 'vue-router'

const PassThroughView: FunctionalComponent = () => h(RouterView)
PassThroughView.displayName = 'RouterView'

function getQueryParams(url: string) {
  if (url.indexOf('?') !== -1) {
    const paramArr = url.slice(url.indexOf('?') + 1).split('&')
    const params: Record<string, LocationQueryValue | LocationQueryValue[]> = {}
    paramArr.forEach((param) => {
      const [key, val] = param.split('=')
      params[key as keyof typeof params] = decodeURIComponent(val || '')
    })
    return params
  }
  return undefined
}

export const routes: RouteRecordRaw[] = [
  // this route is only used to "fake" the redirect for "hybrid-admin"
  {
    path: '/hybrid',
    component: PassThroughView,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    redirect: { name: 'redirect-to-hybrid-admin' },
    children: [
      {
        path: '/hybrid/redirect_to_hybridadmin/',
        name: 'redirect-to-hybrid-admin',
        component: PassThroughView,
        children: [],
        redirect: (to: RouteLocation) => {
          const backUrl = to.query.backUrl as string
          let url
          if (backUrl.split('?').length > 0) {
            url = backUrl.split('?')[0]
          } else {
            url = backUrl
          }
          const additionalParams = getQueryParams(backUrl)
          if (url) {
            return {
              path: url,
              query: { no_redirect: 1, ...additionalParams },
            }
          }
          return {
            name: '/account/profile/',
            query: { ...to.query, no_redirect: 1 },
          }
        },
      },
    ],
  },
]
